///import store from "../store";

import firebase from "firebase";
import axios from "axios";
import store from "../store";
import Environment from "@/components/EnvironmentInit";
import router from "@/router";
import jQuery from "jquery";
let $ = jQuery;

//var iPadLandscapePlayerSupport = false;
var vm;
export default {
	methods: {
		getCDNUrl(path) {
			if (path && path.includes('firebasestorage.googleapis.com')) {
				path = path.replace('https://firebasestorage.googleapis.com/v0/b/', 'https://resources.e2m.live/');
				path = path.replace('/o/', '/');
				return path;
			} else {
				return path;
			}
		},
		getBrandingJSONDetails(path) {
			if (path.includes('EventCustomCSS.json')) {
				const storage = firebase.storage();
				const storageRef = storage.ref();
				var url2 = "https://resources.e2m.live/" + storageRef.bucket + '/' + path;
				return axios.get(url2);
			} else {
				if (store.getters.getBrandingJsonUrl) {
					return axios.get(store.getters.getBrandingJsonUrl);
				} else {
					const storage = firebase.storage();
					const storageRef = storage.ref();
					var url = "https://resources.e2m.live/" + storageRef.bucket + '/' + path;
					return axios.get(url);
				}
			}
		},
		isMobile() {
			return window.innerWidth < 768;
		},
		isIPad() {
			return window.innerWidth == 768;
		},
		isMobileOrIPad() {
			let result = false;
			if (window.innerWidth < 768) {
				result = true;//"mobile_potrait";
			} else if (window.innerHeight < 570) {
				result = true;//"mobile_landscape";
			} else if (window.innerWidth >= 768 && window.innerWidth <= 1024) {
				result = true;//"ipad_potrait";
			}
			return result;
		},
		verifySupportedDevice(toRouteName, toFullPath) {
			vm = this;
			let result = vm.isMobileOrIPad();
			//alert("verifySupportedDevice: " + toFullPath);
			if (result && ["LiveStage", "LiveStageNG", "StageView"].includes(toRouteName)) {
				//if (iPadLandscapePlayerSupport) {
				store.commit("setRouteName", toFullPath);
				//}				
				setTimeout(() => {
					$("#app").removeClass("player");
					$("body").removeClass("player");
				}, 1000);
				router.push("/screeninfo");
			} else {
				//alert(toRouteName);
				//list of valid path needed
				//store.commit("setRouteName", toFullPath);
			}
		},
		needToShowScreenInfo(toRouteName, toFullPath) {
			vm = this;
			let unsupportedDevice = vm.isMobileOrIPad();
			if (unsupportedDevice && ["LiveStage", "LiveStageNG", "StageView"].includes(toRouteName)) {
				store.commit("setRouteName", toFullPath);
				return true;
			}
			else {
				return false;
			}
		},
		// verifyDeviceAfterResize(toRouteName, toFullPath){
		// 	vm = this;
		// 	//alert(vm.$route.name);
		// 	var lastValidPath = store.getters.getRouteName;
		// 	//list of valid path needed
		// 	alert(lastValidPath);
		// 	router.push(lastValidPath);
		// 	if (["LiveStage", "LiveStageNG", "StageView"].includes(toRouteName)) {

		//       debugger;
		//       if (self.verifySupportedDevice(toRouteName, toFullPath)) {
		//         // if (from.name) {
		//         //   store.commit("setRouteName", from.name);
		//         // }
		//         //router.push("/screeninfo");
		//       }
		//   }
		// },
		isValidURL: function (url) {
			var urlPattern = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
			//var urlPattern = /^http[s]*\:\/\/[wwW]{3}\.+[a-zA-Z0-9]+\.[a-zA-Z]{2,3}.*$|^http[s]*\:\/\/[^w]{3}[a-zA-Z0-9]+\.[a-zA-Z]{2,3}.*$|http[s]*\:\/\/[0-9]{2,3}\.[0-9]{2,3}\.[0-9]{2,3}\.[0-9]{2,3}.*$/;
			var regex = new RegExp(urlPattern);
			return regex.test(url);
		},
		isValidEmail: function (email) {
			var emailPattern = /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
			var regex = new RegExp(emailPattern);
			return regex.test(email);
		},
		currentTime: function (offset = 0) {
			return parseInt((new Date().getTime() / 1000).toString()) - offset;
		},
		AddToEventCalendar(service, title, startTimeSeconds, endTimeSeconds, returnAsLink) {
			let timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
			var startTimestamp = this.getEventCalendarDateTime(startTimeSeconds);
			var endTimestamp = this.getEventCalendarDateTime(endTimeSeconds);
			let body = "";
			if (service == "yahoo") {
				body = title + ": To Login Go To " + location.origin.toLowerCase();
			}
			else {
				body = title + "<br/>To Login Go To " + location.origin.toLowerCase();
			}
			var linkUrl =
				"start=" +
				startTimestamp +
				"&end=" +
				endTimestamp +
				"&title=" +
				title +
				"&description=" +
				body +
				"&location=&timezone=" +
				timeZone.replace("/", "%2F") +
				"&service=" +
				service;
			linkUrl =
				"https://www.addevent.com/dir/?client=amFHciuoCzziVYGDHmDp105401&" +
				linkUrl;
			if (returnAsLink) {
				return linkUrl;
			}
			else {
				window.open(linkUrl, "_blank");
			}
		},
		getEventCalendarDateTime: function (sec) {
			var dt = new Date(sec * 1000);
			var years = dt.getFullYear();
			var months = dt.getMonth() + 1;
			var days = dt.getDate();
			var hours = dt.getHours();
			var minutes = dt.getMinutes();
			//var seconds = dt.getSeconds();

			var yearStr = years.toString();
			var monthStr = months.toString();
			var dayStr = days.toString();
			var hourStr = hours.toString();
			var minuteStr = minutes.toString();
			//var secondStr = seconds.toString();
			var ampm = "AM";

			if (months < 10) {
				monthStr = "0" + months.toString();
			}
			if (days < 10) {
				dayStr = "0" + days.toString();
			}
			// if (hours < 10) {
			// 	hourStr = "0" + hours.toString();
			// }
			// if (minutes < 10) {
			// 	minuteStr = "0" + minutes.toString();
			// }
			// if (seconds < 10) {
			// 	secondStr = "0" + seconds.toString();
			// }

			if (hours < 12) {
				ampm = "AM";
			}
			else {
				ampm = "PM";
			}
			if (hours > 12) {
				hours -= 12;
			}
			if (hours < 10) {
				hourStr = "0" + hours.toString() + "%3A";
			} else if (hours < 12) {
				hourStr = hours.toString() + "%3A";
			}

			if (minutes < 10) {
				minuteStr = "0" + minutes.toString() + "+";
			} else {
				minuteStr = minutes.toString() + "+";
			}

			var formattedValue = "";
			formattedValue =
				yearStr +
				"%2F" +
				monthStr +
				"%2F" +
				dayStr.toString() +
				"+" + hourStr + minuteStr + ampm;
			//alert(formattedValue);
			return formattedValue;
		},
		LocalhostDomain() {
			return Environment.LocalhostDomain;
		},
		Environment() {
			return Environment.Instance;
		}
	}
}